import $ from 'jquery'

class MyProfileController {
  constructor (Localization, ValidationRules, RegistrationHelper, $state, $scope, $stateParams, $location, $anchorScroll, I18n, StoreTypes) {
    'ngInject'

    // Set injections
    this.ValidationRules = ValidationRules
    this.RegistrationHelper = RegistrationHelper
    this.$state = $state
    this.$scope = $scope
    this.$stateParams = $stateParams
    this.$location = $location
    this.$anchorScroll = $anchorScroll
    this.I18n = I18n
    this.type = Localization.getLocalizedAppConfig().type
    this.StoreTypes = StoreTypes

    this.isProcessing = false

    this.profile = {}
    this.civilities = this.ValidationRules.civility

    this.checkStep1Params()
  }

  /**
   * Verify state params relative to step 1 - My Profile : civility, first name, last name, email, password and mobile phone
   * If one of these is incorr, the user is redirected to step 1
   */
  checkStep1Params () {
    const civilityChecked = this.RegistrationHelper.checkCivility(this.$stateParams.civility)
    const firstNameChecked = this.RegistrationHelper.checkMaxLength(this.$stateParams.firstName, this.ValidationRules.firstName.maxlength)
    const lastNameChecked = this.RegistrationHelper.checkMaxLength(this.$stateParams.lastName, this.ValidationRules.lastName.maxlength)
    const emailChecked = this.RegistrationHelper.checkEmail(this.$stateParams.email)
    const passwordChecked = this.RegistrationHelper.checkPassword(this.$stateParams.password)
    this.profile.civility = civilityChecked ? this.$stateParams.civility : undefined
    this.profile.firstName = firstNameChecked ? this.$stateParams.firstName : undefined
    this.profile.lastName = lastNameChecked ? this.$stateParams.lastName : undefined
    this.profile.email = emailChecked ? this.$stateParams.email : undefined
    this.profile.password = passwordChecked ? this.$stateParams.password : undefined
    this.profile.passwordConfirmation = passwordChecked ? this.$stateParams.password : undefined
  }

  submit () {
    if (this.$scope.profileForm.$valid) {
      return this.$state.go('registration.myRlink',
        {
          civility: this.profile.civility,
          firstName: this.profile.firstName,
          lastName: this.profile.lastName,
          email: this.profile.email,
          password: this.profile.password,
          model: this.$stateParams.model,
          friendlyName: this.$stateParams.friendlyName,
          vin: this.$stateParams.vin
        })
    } else {
      // Hack for mobile submit button
      this.$scope.profileForm.$submitted = true
      // Scroll to first invalid element
      $('[name="' + this.$scope.profileForm.$name + '"]').find('.ng-invalid:visible:first').focus()
    }
  }

  get isIframe () {
    return (this.type === this.StoreTypes.HELIOS ||
      this.type === this.StoreTypes.MYRENAULT ||
      this.type === this.StoreTypes.RSITE ||
      this.type === this.StoreTypes.ONE)
  }

}
export default MyProfileController



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-profile/my-profile.controller.js